
import * as map from "lodash/map";
import Slider from "react-slick";
import { isWcmEditor } from "config/serverConfig";
import * as classNames from "classnames";
import { RowTickerItemSlot } from "./rowTickerItemSlot";
import { ArticleExtraData } from "articlePage/stateInterfaces";
import { minutesDiff } from "./newsFlashAndTwentyFourSevenMobileComponenta";
import { NewsFlashSpecialSlotItem } from "./newsFlashSpecial/newsFlashSpecialSlotItem";

interface RowTickerListProps {
    seconds: number
    tabHref: string
    displayType: string
    firstArticleId: string
    isFirstInterval: boolean
    siteFlashList: ArticleExtraData[]
    lang?: string
    isLtr?: boolean
    domain?: string
    languageCode?: string
    isShortMode?: boolean
    shouldDisplayLoader?: boolean
    highlightingDuration?: number
}

interface ComponentState {
    openedItemId: string
    rightPosition: number
    openedShareItemId: string
    shouldCarouselAutoplay: boolean
}

const SampleArrow = (props) => {
    const { className, onClick } = props;

    return <div className={className} onClick={onClick} />
}

export class RowTickerList extends React.Component<RowTickerListProps, ComponentState> {
    private slider;
    constructor(props) {
        super(props)
        this.state = {
            openedItemId: null,
            openedShareItemId: null,
            rightPosition: 0,
            shouldCarouselAutoplay: true,
        }
    }

    private handleItemToggle = (articleId: string) => {
        this.setState({ openedItemId: this.state.openedItemId !== articleId ? articleId : null })
        this.dispatchCustomEvent(articleId);
    }

    private handleItemOpened = (articleId: string) => {
        if (this.state.openedItemId !== articleId) {
            this.dispatchCustomEvent(articleId);
        }
        this.setState({ openedItemId: articleId })
    }

    private dispatchCustomEvent = (articleId: string) => {
        const { openedItemId } = this.state;
        const { siteFlashList } = this.props;
        const openIndex = siteFlashList.findIndex(item => item.articleId === articleId);
        const title = siteFlashList[openIndex] && siteFlashList[openIndex].title;
        document.dispatchEvent(
            new CustomEvent("newsFlashesReadMoreChange",
                {
                    detail: {
                        action: articleId === openedItemId ? "Collapse" : "Expand",
                        label: title
                    }
                }
            ))
    }

    private handleShareItemOpened = (articleId: string) => {
        if (this.state.openedShareItemId === articleId) {
            this.setState({ openedShareItemId: null })
        }
        else this.setState({ openedShareItemId: articleId })
    }

    private closeItem = () => {
        if (this.state.openedShareItemId !== null) {
            this.setState({ openedShareItemId: null })
        }
    }

    private handleCarouselAutoplay = (shouldCarouselAutoplay: boolean) => {
        this.setState({ shouldCarouselAutoplay })
    }

    componentDidMount() {
        window.addEventListener('scroll', this.closeItem);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.closeItem);
    }

    componentDidUpdate(prevProps: RowTickerListProps) {
        if (prevProps.shouldDisplayLoader !== this.props.shouldDisplayLoader && this.props.shouldDisplayLoader) {
            this.slider.slickGoTo(6)
        }
    }

    public render() {
        let { siteFlashList, seconds, tabHref, firstArticleId, isFirstInterval, shouldDisplayLoader, highlightingDuration, isShortMode, lang, isLtr, displayType, domain, languageCode } = this.props
        const { openedShareItemId, openedItemId, rightPosition, shouldCarouselAutoplay } = this.state
        if (!siteFlashList || siteFlashList.length === 0) return null;
        const initialSlide = 2; //siteFlashList.findIndex(obj => obj.articleId == firstArticleId);

        let wrappedImageClassNames = isWcmEditor() ? "animationDiv isEditor" : "animationDiv tickerAnimation";

        let settings = {
            draggable: false,
            infinite: true,
            dots: false,
            variableWidth: true,
            // slidesToShow: 3.56,
            slidesToScroll: 1,
            autoplay: shouldCarouselAutoplay ? seconds > 0 : false,
            autoplaySpeed: seconds * 1000,
            pauseOnHover: true,
            arrows: true,
            rtl: !isLtr,
            centerMode: false,
            beforeChange: (current, next) => {
                this.setState({ openedShareItemId: null, openedItemId: null })
                return this.setState({ rightPosition: siteFlashList && siteFlashList.length > 0 && (siteFlashList.length - 1 - current) * (1144 / siteFlashList.length) })
            },
            initialSlide: isLtr ? 0 : 3,
            nextArrow: <SampleArrow />,
            prevArrow: <SampleArrow />,

        }

        if (!siteFlashList || siteFlashList.length == 0) {
            return null
        }

        return (
            <div className={classNames("slotListRow")}  >
                <Slider {...settings} className={wrappedImageClassNames} ref={slider => (this.slider = slider)}>
                    {map(siteFlashList, (flashItem, i) => {
                        const newItem = minutesDiff(flashItem) < highlightingDuration;
                        return displayType === "special" ?
                            <NewsFlashSpecialSlotItem
                                isLTR={isLtr}
                                nextRoof={""}
                                domain={domain}
                                previousRoof={""}
                                article={flashItem}
                                roofOngoingEvent={false}
                                key={flashItem.articleId}
                                languageCode={languageCode}
                                openedItemId={openedItemId}
                                isFirstInterval={isFirstInterval}
                                onRowItemToggle={this.handleItemToggle}
                                highlightingDuration={highlightingDuration}
                                handleCarouselAutoplay={this.handleCarouselAutoplay}
                            />
                            :
                            <RowTickerItemSlot
                                key={i}
                                lang={lang}
                                tabHref={tabHref}
                                newItem={newItem}
                                roof={flashItem.roof}
                                title={flashItem.title}
                                isShortMode={isShortMode}
                                author={flashItem.author}
                                openedItemId={openedItemId}
                                link={flashItem.publishedLink}
                                articleId={flashItem.articleId}
                                flashText={flashItem.plainText}
                                isFirstInterval={isFirstInterval}
                                onOpenItem={this.handleItemOpened}
                                openedShareItemId={openedShareItemId}
                                flashDate={flashItem.dateUpdatedOnSite}
                                onToggleOpenItem={this.handleItemToggle}
                                onOpenShareItemButtons={this.handleShareItemOpened}
                                isFirstItem={firstArticleId === flashItem.articleId}
                                shouldDisplayLoader={shouldDisplayLoader && firstArticleId === flashItem.articleId}
                            />
                    })}
                </Slider>
            </div>
        )
    }
}